import { Block } from "../../factories/types";
import { TestimonialsClient } from "./TestimonialsClient";

// TOOO(khaney): Isolate the client side behavior and move the majority of the code back to this file
export const Testimonials: Block<'testimonials'> = ({ data }) =>
  <TestimonialsClient {...data} />;
